import {
  GET_DATA_CHAT,
  GET_AGENT_STATE,
  GET_SOLVED_CHAT,
  GET_CHAT_AGENT,
  GET_SUMMARY_AGENT,
  GET_SUMMARY_RESULT,
  GET_SUMMARY_SOLVED,
} from "../Types/DashboardTypes";

const dashState = {
  chatCount: {},
  agentState: [],
  chatSolved: [],
  chatAgent: [],
  summaryAgent: [],
  summaryResult: [],
  summarySolved: [],
};

export const dashboardReducer = (state = dashState, action) => {
  const { payload, type } = action;

  if (type === GET_DATA_CHAT) {
    return {
      ...state,
      chatCount: payload,
    };
  }

  if (type === GET_AGENT_STATE) {
    return {
      ...state,
      agentState: payload,
    };
  }

  if (type === GET_SOLVED_CHAT) {
    return {
      ...state,
      chatSolved: payload,
    };
  }

  if (type === GET_CHAT_AGENT) {
    return {
      ...state,
      chatAgent: payload,
    };
  }

  if (type === GET_SUMMARY_AGENT) {
    return {
      ...state,
      summaryAgent: payload,
    };
  }
  if (type === GET_SUMMARY_RESULT) {
    return {
      ...state,
      summaryResult: payload,
    };
  }
  if (type === GET_SUMMARY_SOLVED) {
    return {
      ...state,
      summarySolved: payload,
    };
  }

  return state;
};
